import { getStorageItem, removeStorageItem, setStorageItem } from '../utils/storage';
import { MixpanelService } from './MixpanelService';

const LOCAL_STORAGE_LEAD_ID_KEY = 'event-lead-id';

export class EventAliasingService {
  constructor(private readonly mixpanelService: MixpanelService) {}
  public saveLeadId = (identity: string) => {
    setStorageItem(LOCAL_STORAGE_LEAD_ID_KEY, identity);
  };

  public hasLeadIdStored = (): boolean => {
    return !!getStorageItem(LOCAL_STORAGE_LEAD_ID_KEY);
  };

  public linkLeadAndProvider = (newProviderUserId: string) => {
    const oldLeadUserId = getStorageItem(LOCAL_STORAGE_LEAD_ID_KEY);
    if (!oldLeadUserId) {
      return;
    }

    this.mixpanelService.alias(newProviderUserId, oldLeadUserId);
    removeStorageItem(LOCAL_STORAGE_LEAD_ID_KEY);
  };
}
